import { ConfirmDiscardComponent } from './dialog/confirm-discard/confirm-discard.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';
import { ClipboardModule } from 'ngx-clipboard';

// Header / Footer / Side Navigation / Staff Components.
import { LogoTitleComponent } from './header-footer/logo/logo-title.component';

//Search Components
import { GalleryViewComponent } from './search/gallery-view/gallery-view.component';
import { ListViewComponent } from './search/list-view/list-view.component';
import { SearchResourcesComponent } from './search/search-resources/search-resources.component';

// SideNav Components
import { AddListComponent } from './side-nav/add-list/add-list.component';
import { ClearHistoryDialog } from './side-nav/search-history/clear-history-dialog/clear-history-dialog.component';
import { EmailComponent } from './side-nav/email/email.component';
import { MoreDetailsDialog } from './side-nav/search-history/more-details-dialog/more-details-dialog.component';
import { NotifyComponent } from './side-nav/notify/notify.component';
import { ProfileNavComponent } from './side-nav/profile-nav/profile-nav.component';
import { SearchHistoryComponent } from './side-nav/search-history/search-history.component';
import { StaffFullRecordComponent } from './side-nav/staff-full-record/staff-full-record.component';
import { StaffMenuComponent } from './side-nav/staff-menu/staff-menu.component';

import { SmsComponent } from './side-nav/sms/sms.component';
import { CopyLinkComponent } from './side-nav/copy-link/copy-link.component';

import { GuestIllTrackingComponent } from './side-nav/guest-ill-tracking/guest-ill-tracking.component';
import { ForgotPasswordComponent } from './side-nav/forgot-password/forgot-password.component';
import { WebLinksDialog } from './your-settings/your-web-links/dialogs/web-links-dialog/web-links-dialog.component';
import { CheckoutHistoryDialog } from './item-details/checkout-history/dialogs/checkout-hisotry-dialog/checkout-hisotry-dialog.component';
import { FineLostItemDialog } from './item-details/fine-lost-item/dialogs/fine-lost-item-dialog/fine-lost-item-dialog.component';
import { ScoresDialog } from './search/dialogs/scores-dialog/scores-dialog.component';
import { RenewDialog } from './item-details/items-out/dialogs/renew-dialog/renew-dialog.component';
import { DeleteItemsDialog } from './item-details/items-hold/dialogs/delete-items-dialog/delete-items-dialog.component';
import { DeleteSingleItemDialog } from './item-details/items-hold/dialogs/delete-single-item-dialog/delete-single-item-dialog.component';
import { LanguagesComponent } from './side-nav/languages/languages.component';
import { ScriptHackComponent } from './plugins/scripthack/scripthack.component';
import { WebLinksTabComponent } from './side-nav/web-links-tab/web-links-tab.component';
import { ShareitHoldingsComponent } from './search/shareit-holdings/shareit-holdings.component';
import { DetailsSnackbar } from './messages/details-snackbar/details-snackbar.component';
import { NotificationsDialog } from './side-nav/notify/notifications-dialog/notifications-dialog.component';
import { PipesSharedModule } from '../shared/pipes/pipes.module';
import { LegacyStaffModule } from '../modules/shared/staff/legacy-staff.module';
import { SearchSharedModule } from '../modules/shared/search-shared/search-shared.module';
import { EditCSharedModule } from '../modules/shared/edit-c-shared/edit-c-shared.module';
import { AlertLendingPolicyDialog } from './staff/dialogs/policies/alert-lending-policy-dialog/alert-lending-policy-dialog.component';
import { PrintPageComponent } from './ui/print-page/print-page.component';
import { HoldingsComponent } from './search/gallery-view/holdings/holdings.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { SharedModule } from '../shared/shared.module';
import { DirectiveModule } from '../shared/directives/directive.module';
import { PageStickyComponent } from './page-sticky/page-sticky.component';
import { ScrollAreaComponent } from './scroll-area/scroll-area.component';
import { RequiredFieldDialog } from './required-field-dialog/required-field-dialog.component';
import { DocumentPickerDialogComponent } from './search/document-picker-dialog/document-picker-dialog.component';
import { ResultsViewComponent } from './search/results/results-view.component';
import { SearchAlertDialog } from './search/dialogs/search-alert.dialog/search-alert.dialog';
import { AddPatronErrorDialog } from './side-nav/patron-search/dialog/add-patron-error.dialog';
import { DynamicFormFieldComponent } from './dynamic-form/dynamic-form-field.component';
import { CarouselComponent } from './carousel/carousel.component';
import { CheckboxGroupComponent } from './dynamic-form/checkbox-group/checkbox-group.component';
import { CarouselItemComponent } from './carousel/carousel-item/carousel-item.component';
import { LayoutHeaderComponent } from '../layouts/main-v6-layout/layout-header/layout-header.component';
import { ContentComponent } from '../layouts/main-v6-layout/page-layout/content/content.component';
import { DrawerLayoutComponent } from '../layouts/main-v6-layout/drawer-layout/drawer-layout.component';
import { PageLayoutComponent } from '../layouts/main-v6-layout/page-layout/page-layout.component';
import { ContentHeaderComponent } from '../layouts/main-v6-layout/page-layout/content-header/content-header.component';
import { InfoComponent } from '../shared/components/info/info.component';
import { DialogComponent } from './dialog/dialog.component';
import { BibMetadataComponent } from './bib-metadata/bib-metadata.component';
import { FilterSelectComponent } from './filter-select/filter-select.component';
import { PrintIframeComponent } from './print-iframe/print-iframe.component';
import { Loc1SelectComponent } from './loc1-select/loc1-select.component';
import { DynamicUserFormComponent } from './dynamic-form/dynamic-user-form.component';
import { ODataGroupComponent } from './odata-form/odata-group/odata-group.component';
import { ODataRowComponent } from './odata-form/odata-row/odata-row.component';
import { ODataFormComponent } from './odata-form/odata-form.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { LibrarySelectComponent } from './library-select/library-select.component';
import { OdataEditFormComponent } from './odata-edit-form/odata-edit-form.component';
import { OdataEditRowComponent } from './odata-form/odata-edit-row/odata-edit-row.component';
import { TableGridModule } from './table/table-grid/table-grid.module';
import { AnnouncementsBannerModule } from './announcements-banner/announcements-banner.module';
import { ReorderContextMenuModule } from './reorder-context-menu/reorder-context-menu.module';

@NgModule({
  imports: [
    EditCSharedModule,
    SearchSharedModule,
    LegacyStaffModule,
    TableGridModule,
    NgbModule,
    RouterModule,
    ColorPickerModule,
    SharedModule,
    ClipboardModule,
    DirectiveModule,
    AnnouncementsBannerModule,
    ReorderContextMenuModule,
  ],
  declarations: [
    // Header / Footer Elements
    LogoTitleComponent,
    // Search
    GalleryViewComponent,
    ListViewComponent,
    ResultsViewComponent,
    SearchResourcesComponent,
    // SideNav Components
    AddListComponent,
    NotifyComponent,
    StaffFullRecordComponent,
    StaffMenuComponent,
    EmailComponent,
    ProfileNavComponent,
    SearchHistoryComponent,
    MoreDetailsDialog,
    ClearHistoryDialog,
    SmsComponent,
    CopyLinkComponent,
    GuestIllTrackingComponent,
    ForgotPasswordComponent,
    WebLinksDialog,
    CheckoutHistoryDialog,
    FineLostItemDialog,
    ScoresDialog,
    RenewDialog,
    DeleteItemsDialog,
    DeleteSingleItemDialog,
    LanguagesComponent,
    ScriptHackComponent,
    WebLinksTabComponent,
    ShareitHoldingsComponent,
    DetailsSnackbar,
    NotificationsDialog,
    AlertLendingPolicyDialog,
    PrintPageComponent,
    HoldingsComponent,
    DynamicFormComponent,
    DynamicUserFormComponent,
    PageStickyComponent,
    ScrollAreaComponent,
    RequiredFieldDialog,
    DocumentPickerDialogComponent,
    SearchAlertDialog,
    DynamicFormFieldComponent,
    AddPatronErrorDialog,
    CarouselComponent,
    CheckboxGroupComponent,
    CarouselItemComponent,
    LayoutHeaderComponent,
    ContentHeaderComponent,
    ContentComponent,
    PageLayoutComponent,
    DrawerLayoutComponent,
    InfoComponent,
    DialogComponent,
    BibMetadataComponent,
    FilterSelectComponent,
    PrintIframeComponent,
    Loc1SelectComponent,
    ODataFormComponent,
    ODataGroupComponent,
    ODataRowComponent,
    DateRangeComponent,
    LibrarySelectComponent,
    ODataFormComponent,
    ODataGroupComponent,
    ODataRowComponent,
    DateRangeComponent,
    ConfirmDiscardComponent,
    OdataEditFormComponent,
    OdataEditRowComponent,
  ],
  exports: [
    EditCSharedModule,
    PipesSharedModule,
    //modules
    ColorPickerModule,
    LegacyStaffModule,
    ReorderContextMenuModule,
    // Header / Footer Elements
    LogoTitleComponent,
    TableGridModule,
    // Search
    GalleryViewComponent,
    ListViewComponent,
    ResultsViewComponent,
    SearchResourcesComponent,
    // SideNav Components
    AddListComponent,
    NotifyComponent,
    StaffFullRecordComponent,
    StaffMenuComponent,
    EmailComponent,
    ProfileNavComponent,
    DetailsSnackbar,
    // UI Components
    SearchHistoryComponent,
    SmsComponent,
    CopyLinkComponent,
    GuestIllTrackingComponent,
    ForgotPasswordComponent,
    LanguagesComponent,
    ScriptHackComponent,
    WebLinksTabComponent,
    ShareitHoldingsComponent,
    // FileUploadModule,
    ClipboardModule,
    DirectiveModule,
    WebLinksDialog,
    CheckoutHistoryDialog,
    FineLostItemDialog,
    ScoresDialog,
    RenewDialog,
    DeleteItemsDialog,
    DeleteSingleItemDialog,
    PrintPageComponent,
    DynamicFormComponent,
    DynamicUserFormComponent,
    PageStickyComponent,
    ScrollAreaComponent,
    RequiredFieldDialog,
    DynamicFormFieldComponent,
    CarouselComponent,
    CheckboxGroupComponent,
    CarouselItemComponent,
    LayoutHeaderComponent,
    ContentHeaderComponent,
    ContentComponent,
    PageLayoutComponent,
    DrawerLayoutComponent,
    InfoComponent,
    DialogComponent,
    BibMetadataComponent,
    FilterSelectComponent,
    PrintIframeComponent,
    Loc1SelectComponent,
    ODataFormComponent,
    ODataGroupComponent,
    ODataRowComponent,
    DateRangeComponent,
    LibrarySelectComponent,
    ODataFormComponent,
    ODataGroupComponent,
    ODataRowComponent,
    DateRangeComponent,
    ConfirmDiscardComponent,
    OdataEditFormComponent,
    OdataEditRowComponent,
    AnnouncementsBannerModule,
  ],
})
export class ComponentsModule {}
